import * as v from "@badrap/valita";

import { $PositiveInteger } from "./misc.ts";
import { $ProductId } from "./product.ts";

export const $OrderId = v.string();

export type OrderId = v.Infer<typeof $OrderId>;

export const $Order = v.object({
  id: $OrderId,
  items: v.array(
    v.object({
      id: $ProductId,
      qty: $PositiveInteger,
    }),
  ),
  datetime: v.string(),
  note: v.string(),
});

export type Order = v.Infer<typeof $Order>;

export const $OrderNew = $Order.omit("id", "datetime");

export type OrderNew = v.Infer<typeof $OrderNew>;

export const $OrderUpdate = $Order.omit("id").partial();

export type OrderUpdate = v.Infer<typeof $OrderUpdate>;
